export default "/images/testimonial-bg.png?c5a704a2e33a7c2e396960378156463c";